import { render, staticRenderFns } from "./ModalStylesPage.vue?vue&type=template&id=435e2e92&"
import script from "./ModalStylesPage.vue?vue&type=script&lang=js&"
export * from "./ModalStylesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports